<nz-tag [nzColor]="tagColor" nz-tooltip [nzTooltipTitle]="getTooltipTitle()" (click)="openUuidModal()">
  <i *ngIf="showSuccessIcon" nz-icon nzType="check-circle" nzTheme="outline" class="text-success"></i>
  {{ displayValue }}
</nz-tag>

<app-uuid-modal (statusChange)="onStatusChange($event)" #uuidModal></app-uuid-modal>

